export default __webpack_public_path__ + "static/media/welcome_illustration.accc7eba.svg";